import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface LoginPromptModalProps {
  isOpen: boolean;
  onClose: () => void;
  onLogin?: () => void;
}

export function LoginPromptModal({
  isOpen,
  onClose,
  onLogin
}: LoginPromptModalProps) {
  const navigate = useNavigate();
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleLogin = () => {
    if (onLogin) {
      onLogin();
    } else {
      // 로그인 페이지로 이동
      navigate('/login');
    }
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center pointer-events-none">
      <div className="relative bg-white rounded-xl mx-4 w-full max-w-[320px] shadow-xl border border-gray-200 pointer-events-auto">
        <div className="p-6">
          <h3 className="text-center text-lg font-semibold text-gray-900 mb-2">
            로그인이 필요합니다
          </h3>
          
          <p className="text-center text-sm text-gray-600 mb-6">
            이 기능을 사용하려면 로그인해주세요
          </p>
          
          <div className="flex gap-3">
            <button
              onClick={onClose}
              className="flex-1 py-3 px-4 bg-gray-100 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-200 transition-colors"
            >
              취소
            </button>
            
            <button
              onClick={handleLogin}
              className="flex-1 py-3 px-4 bg-green-500 text-white rounded-lg text-sm font-medium hover:bg-green-600 transition-colors"
            >
              로그인하기
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}